// extracted by mini-css-extract-plugin
export var block = "style-module--block--76214";
export var offer = "style-module--offer--b51c9";
export var wrapper = "style-module--wrapper--585d9";